import React, {Fragment} from 'react'
import Header from '../../components/header'
import PageTitle from '../../components/pagetitle'
import Feature from '../../components/feature'
import Partners from '../../components/partners'
import Expertise from '../../components/expertise'
import Team from '../../components/team'
import Footer from '../../components/footer'
import { usedTools } from '../../Dashboard/dashboard';
import { clients } from '../../Dashboard/dashboard';
import { partners } from '../../Dashboard/dashboard';

const AboutPage =() => {
    return(
        <Fragment>
            <Header/>
            <PageTitle pageTitle={'About Us'} pagesub={'About'}/>
            <Feature/>
            <Partners usedTools={usedTools} clients={clients} partners={partners} />
            <Expertise/>
            <Team/>
            <Footer/>
        </Fragment>
    )
};
export default AboutPage;

